import React, { ComponentType } from 'react'
import { Provider } from 'react-redux'
import store from '.'

export function withReduxWrapper<P>(Component: ComponentType<P>): ComponentType<P> {
    const WrappedBySuspense: React.FC<P> = props => (
        <Provider store={store}>
            <Component {...props} />
        </Provider>
    )

    return WrappedBySuspense
}
